module.exports = __webpack_public_path__ + "img/menu1.e371fed4.png";